import { debounce, DebounceSettings } from 'lodash';
import React from "react";
import { TimeSpan } from '../TimeSpan';

const useDebouncedEffect = (
    callback: Function,
    dependencies: any[],
    delay: TimeSpan,
    options?: DebounceSettings
) => {

    return React.useEffect(debounce((...args) => {
        callback(...args);
    }, delay.milliseconds, options), [...dependencies]);
};

export default useDebouncedEffect;
